import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";

const colorClasses = {
  error: {
    main: "border-errorRed text-errorRed bg-white shadow-lg",
    icon: "text-errorRed hover:text-errorRed/50",
  },
  success: {
    main: "border-successGreen text-successGreen bg-white shadow-lg",
    icon: "text-successGreen hover:text-successGreen/50",
  },
  warning: {
    main: "border-coralRed text-coralRed bg-white shadow-lg",
    icon: "text-coralRed hover:text-coralRed/50",
  },
  info: {
    main: "border-salmonPink text-ashGray bg-white shadow-lg",
    icon: "text-ashGray hover:text-ashGray/50",
  },
};

const Alert = ({
  title,
  message,
  showAlert,
  setShowAlert,
  colorClass,
  duration = 5000,
}) => {
  const [slideOut, setSlideOut] = useState(false);

  useEffect(() => {
    if (showAlert) {
      const timer = setTimeout(() => {
        setSlideOut(true);
        setTimeout(() => {
          setShowAlert(false); // Set showAlert to false after slide out
        }, 300); // Wait for slide out animation to finish
      }, duration); // Use the duration prop
      setSlideOut(false);
      return () => clearTimeout(timer);
    }
  }, [showAlert, setShowAlert, duration]);

  if (!showAlert) return null;

  return (
    <div
      className={`${colorClasses[colorClass].main} border px-4 py-3 rounded fixed top-4 right-4 z-[100] block transition-transform duration-600 ${slideOut ? "translate-x-full" : ""}`}
      role="alert"
      data-testid="alert"
    >
      <strong className="font-bold mr-2" data-testid="alert-title">
        {title}
      </strong>
      <span className="block mr-2" data-testid="alert-message">
        {message}
      </span>
      <span className="absolute top-0 bottom-0 right-0 px-4 py-3 mr-2">
        <svg
          className={`${colorClasses[colorClass].icon} fill-current h-6 w-6 hover:cursor-pointer transition-all duration-300 ease-in-out`}
          role="button"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 20 20"
          onClick={() => setShowAlert(false)}
          data-testid="alert-close"
        >
          <title>Close</title>
          <path d="M14.348 14.849a1.2 1.2 0 0 1-1.697 0L10 11.819l-2.651 3.029a1.2 1.2 0 1 1-1.697-1.697l2.758-3.15-2.759-3.152a1.2 1.2 0 1 1 1.697-1.697L10 8.183l2.651-3.031a1.2 1.2 0 1 1 1.697 1.697l-2.758 3.152 2.758 3.15a1.2 1.2 0 0 1 0 1.698z" />
        </svg>
      </span>
    </div>
  );
};

Alert.propTypes = {
  title: PropTypes.string.isRequired,
  message: PropTypes.string.isRequired,
  showAlert: PropTypes.bool.isRequired,
  setShowAlert: PropTypes.func.isRequired,
  colorClass: PropTypes.string.isRequired,
  duration: PropTypes.number,
};

export default Alert;
